export const initMobileMenu = () => {
  const burger = document.querySelector('.burger');
  const menu = document.getElementById('mobile-menu');
  if (!burger || !menu) return;

  const closeBtn = menu.querySelector('.mobile-menu__close');
  const links = menu.querySelectorAll('a');

  const open = () => {
    menu.classList.add('is-open');
    menu.setAttribute('aria-hidden', 'false');
    burger.setAttribute('aria-expanded', 'true');
    document.documentElement.classList.add('is-menu-open');
    closeBtn.focus();
  };

  const close = () => {
    menu.classList.remove('is-open');
    menu.setAttribute('aria-hidden', 'true');
    burger.setAttribute('aria-expanded', 'false');
    document.documentElement.classList.remove('is-menu-open');
    burger.focus();
  };

  burger.addEventListener('click', open);
  closeBtn.addEventListener('click', close);
  links.forEach((link) => link.addEventListener('click', close));

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && menu.classList.contains('is-open')) {
      close();
    }
  });
};
